import ApiConnector from "@/repository/connector";

class Classifiers {
  get = async () => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/core/classifiers/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
}

export default new Classifiers()